import { InfoOutlined } from "@mui/icons-material";
import {
  Box, Button,
  ButtonGroup,
  ClickAwayListener,
  Paper, Popover
} from "@mui/material";
import * as React from "react";
import Joyride from "react-joyride";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ROUTES } from "../../../constants";
import { IUserStoreState, useUserStore } from "../../../store/userState";
import QuickOverview from "../../dashboard/widgetLibrary/quickOverview";

const QuickStartButton: React.FC<RouteComponentProps> = ({ history }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const { logout } = useUserStore((state) => state) as IUserStoreState;
  const [view, setView] = React.useState(
    null as "QUICK_START" | "WHATS_NEW" | null
  );
  const [tour, setTour] = React.useState(false);
  const steps = [
    {
      target: '.Overview',
      content: 'Get a high-level view of all Projects and Issues, providing insights into their current status and key metrics.',
      disableBeacon: true,
    },
    {
      target: '.Projects',
      content: 'View and manage all your Projects, including their Assets and the real-time status of all associated Issues.',
      disableBeacon: true,
    },
    {
      target: '.Issues',
      content: 'Access a comprehensive list of all Issues, with a concise summary for quick assessment and prioritization.',
      disableBeacon: true,
    },
    {
      target: '.Runs',
      content: 'Track all scans completed by Aptori, with a summary of results for each scan to quickly evaluate security findings.',
      disableBeacon: true,
    },
    {
      target: '.Configurations',
      content: 'Use the interactive wizard to create, manage, and fine-tune Aptori configurations for seamless security management.',
      disableBeacon: true,
    },
    {
      target: '.Jobs',
      content: 'Schedule Cloud Run jobs to scan your code, APIs, and applications for vulnerabilities.',
      disableBeacon: true,
    },
    {
      target: '.Reports',
      content: 'Generate detailed insights into your entire asset inventory for comprehensive visibility.',
      disableBeacon: true,
    },
    {
      target: '.GeneratorSets',
      content: 'Define global variables for use in API scans to standardize configurations.',
      disableBeacon: true,
    },
    {
      target: '.Policies',
      content: 'Create and enforce detection rules to inspect and secure your APIs effectively.',
      disableBeacon: true,
    },
    
    {
      target: '.Documentation',
      content: 'Contains essential information, instructions, and guidelines for Aptori.',
      disableBeacon: true,
    },
    {
      target: '.Downloads',
      content: 'Provides access to downloadable files.',
      disableBeacon: true,
    },
    
    {
      target: '.ConvertHAR',
      content: 'Converts HTTP Archive (HAR) files to another format.',
      disableBeacon: true,
    },
    {
      target: '.MergeOpenAPI',
      content: 'Combines OpenAPI specifications or documents.',
      disableBeacon: true,
    },
    {
      target: '.Groups',
      content: 'Organizes entities into categories or collections.',
      disableBeacon: true,
    },
    {
      target: '.Keys',
      content: 'Manages access keys or security credentials.',
      disableBeacon: true,
    },
  ];

  const handleToggle = (view: any) => {
    setView(view);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setView(null);
    setOpen(false);
  };

  const tourCallback = (tour: any) => {
    const { action } = tour
    if (action === "reset") {
      setTour(false)
    }
    if (action === 'close') {
      setTour(false)
    }
  }

  return (
    <Box >
      <ButtonGroup
        sx={{ width: "100%" }}
        ref={anchorRef}
        size="small"
      >

        <Button color="secondary" size="small"
          variant="text" onClick={() => setTour(true)}><Box sx={{ display: "flex", justifyContent: "start" }}>
            <InfoOutlined sx={{ pr: 1 }} />
            Walkthrough</Box></Button>

        <Button
          size="small"
          variant="text"
          color="inherit"
          // onClick={() => history.push(ROUTES.QUICK_START)}
          onClick={() => handleToggle("QUICK_START")}
          sx={{
            textAlign: "left",
            textTransform: "none",
            // width: "100%",
            // px:0
          }}
        >
          Quick Start
        </Button>
        <Button
          size="small"
          variant="text"
          color="inherit"
          onClick={() => handleToggle("WHATS_NEW")}
          sx={{
            textAlign: "left",
            // textTransform: "none",
            // minWidth: "11em",
            // px:0
          }}
        >
          What's New
        </Button>
      </ButtonGroup>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        sx={{ maxWidth: "1000em" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        disablePortal
        id="popper-add-universal"
      >
        {/* {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            minWidth: "20em",
                            zIndex: 999,
                            transformOrigin:
                                placement === 'bottom' ? 'left top' : 'left bottom',
                        }}
                    > */}
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <Box>
              <QuickOverview view={view} />
            </Box>
          </ClickAwayListener>
        </Paper>
        {/* </Grow>
                )} */}
      </Popover>
      <Joyride
        steps={steps}

        styles={{
          tooltipContent: {
            textAlign: "left",
          },
          tooltip: {
            borderRadius: "1em",
          },
          options: {
            arrowColor: '#e3ffeb',
            backgroundColor: '#e3ffeb',
            primaryColor: '#000',
            textColor: '#004a14',

            zIndex: 1000,
          }
        }}
        floaterProps={{
          disableAnimation: true
        }}
        spotlightPadding={0}
        continuous
        debug
        callback={tourCallback}
        run={tour}

      />
    </Box>
  );
};

export default withRouter(QuickStartButton);